import { SKYSCAPE_BASKET_ERROR_CODES } from 'constants/basket';
import {
  ATGBasketErrorResponse,
  BasketAmendItemParams,
  ODMBasketErrorResponse,
  SkyscapeBasketErrorResponse,
} from 'types/BasketTypes';

export const isATGBasketErrorResponse = (response: unknown): response is ATGBasketErrorResponse =>
  !!(typeof response === 'object' && response !== null && ('formExceptions' in response || 'formError' in response));

export const isSkyscapeBasketErrorResponse = (response: unknown): response is SkyscapeBasketErrorResponse => {
  const errors = (response as SkyscapeBasketErrorResponse)?.errors;
  return Array.isArray(errors) && errors.some((error) => SKYSCAPE_BASKET_ERROR_CODES.includes(error.key));
};

export const isODMBasketErrorResponse = (response: unknown): response is ODMBasketErrorResponse => {
  const errors = (response as ODMBasketErrorResponse)?.error?.errors;
  return Array.isArray(errors) && errors.some((error) => SKYSCAPE_BASKET_ERROR_CODES.includes(error.key));
};

export const getAmendBasketParams = (): BasketAmendItemParams => {
  const params = new URLSearchParams(window.location.search);

  return {
    amendItemId: params.get('amendItemId'),
    variantId: params.get('variantId'),
  };
};

export const isAmendBasketEnabled = (
  params: BasketAmendItemParams,
): params is { amendItemId: string; variantId: string } => !!(params.amendItemId && params.variantId);
